/**
 * returns selected figures at the and of the list
 */
export const reorderFigures = (figureIds: string[], selectedIds: string[]): string[] => ([
  ...(figureIds.filter((figureId: string) => !selectedIds.includes(figureId))),
  ...(figureIds.filter((figureId: string) => selectedIds.includes(figureId))),
]);
